import { render, staticRenderFns } from "./CW.vue?vue&type=template&id=0fc57ad6&scoped=true&"
import script from "./CW.vue?vue&type=script&lang=js&"
export * from "./CW.vue?vue&type=script&lang=js&"
import style0 from "./CW.vue?vue&type=style&index=0&id=0fc57ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc57ad6",
  null
  
)

export default component.exports